<template>
  <a-modal :open="open" @cancel="closeForm">
    <h2>Приглашение сотрудника: ({{ currentActionUser?.name ? currentActionUser?.name : (currentActionUser?.first_name ?? selectedUsers.length) }})</h2>
    <a-divider style="margin: 16px 0" />
    <p class="modal-text">
      Отправить на почту письмо с данными для входа в личный кабинет сотрудника.
    </p>

    <template #footer>
      <a-divider />
      <div class="action-buttons">
        <a-row justify="end" :gutter="8">
          <a-col>
            <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
          </a-col>
          <a-col>
            <a-button class="primary-button" :loading="modalActionLoading" @click="handleInviteNotifications">Отправить</a-button>
          </a-col>
        </a-row>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {ref} from "@vue/runtime-core";

export default {
  props: {
    open: Boolean,
    currentActionUser: Object,
    selectedUsers: Array,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);
    const groupToCopyIn = ref();

    const handleInviteNotifications = () => {
      modalActionLoading.value = true;

      let users = [];
      if (props.currentActionUser?.id) {
        users.push(props.currentActionUser.id);
      } else {
        users = props.selectedUsers;
      }

      store.dispatch('users/sendStaffNotification', {users: users}).then(() => {
        message.success('Приглашения отправлены');
        context.emit('submitted')
      }).finally(() => {
        modalActionLoading.value = false;
      });
    }

    const closeForm = () => {
      context.emit('close');
    }

    return {
      groupToCopyIn,
      modalActionLoading,
      closeForm,
      handleInviteNotifications
    }
  }
}
</script>

<style scoped lang="scss">

</style>